import SelectionReport from '@console/components/project/SelectionReport';
import type { AppState } from '@console/reducers/index';
import {
  getIsApiProject,
  getIsBulkProject,
  getIsGcpProject
} from '@console/selectors/projectDetail/solutionSystem';
import { connect } from 'react-redux';

const mapStateToProps = (state: AppState) => ({
  isApiProject: getIsApiProject(state),
  isBulkProject: getIsBulkProject(state),
  isGcpProject: getIsGcpProject(state)
});

const mapDispatchToProps = () => ({});

export type SelectedGifteeBoxReportsPropsMappedFromState = ReturnType<
  typeof mapStateToProps
>;

export type SelectedGifteeBoxReportsPropsMappedFromDispatch = ReturnType<
  typeof mapDispatchToProps
>;

export default connect(mapStateToProps, mapDispatchToProps)(SelectionReport);
